import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import CropPDFImagesListScreen from "./CropPDFImagesListScreen";
import { BASE_URL } from "../Config";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function CropPDFMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "Crop PDF Files" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/crop_pdf", title: "Crop PDF Online" },
    data2: { link: "/crop_pdf", title: "PDF Cropper" },
    data3: { link: "/crop_pdf", title: "Trim PDF Files" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Crop PDF online easily. Trim PDF pages, remove unwanted areas, and edit documents quickly with our fast, secure, and easy PDF crop tool."
      ></meta>
      <meta
        name="keywords"
        content="crop PDF, crop PDF online, trim PDF pages, PDF page cropper, PDF editor online, edit PDF pages, remove PDF margins, PDF page editor, online PDF crop tool, adjust PDF pages, PDF management tool, crop PDF documents, PDF trimming tool, crop PDF fast, resize PDF pages, pdf cropper"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <CropPDFImagesListScreen title={title}></CropPDFImagesListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Crop PDF website provides a fast, secure, and efficient way to trim and adjust PDF pages without requiring an internet connection. Designed to work fully offline, this powerful tool allows users to remove unwanted margins, borders, or white spaces while keeping the original content intact. Whether you are editing scanned documents, preparing files for printing, or optimizing PDFs for sharing, this offline-ready solution helps you achieve precise results effortlessly. Users can crop PDF online when needed or process files completely offline for maximum privacy and security. With an intuitive interface, this advanced PDF cropper makes it easy to select specific areas, apply consistent cropping across multiple pages, and preview changes in real time. The platform also functions as a reliable PDF trimmer online, enabling users to resize pages accurately without affecting text clarity or image quality. Ideal for students, professionals, and businesses, this tool preserves document layout while reducing file size and improving visual presentation. If you are looking for a dependable crop PDF online, a user-friendly PDF cropper, or a secure PDF trimmer online with offline support, this website delivers a smooth and modern document workflows." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Crop",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Crop PDF Tool"
            why_use={[
              {
                title: "Remove Unwanted Margins and White Space",
                description:
                  "Our crop PDF tool helps remove extra margins and blank spaces, making PDF documents cleaner and more professional.",
              },
              {
                title: "Improve Document Appearance",
                description:
                  "Using crop PDF online enhances visual presentation by focusing only on important content.",
              },
              {
                title: "Optimize PDFs for Printing",
                description:
                  "This PDF cropper ensures proper page alignment and prevents important content from being cut off during printing.",
              },
              {
                title: "Reduce PDF File Size",
                description:
                  "Cropping unused areas helps reduce file size. A PDF trimmer online optimizes PDFs for easy sharing and storage.",
              },
              {
                title: "Perfect for Scanned Documents",
                description:
                  "Scanned PDFs often have uneven borders. A crop PDF tool corrects alignment issues and improves readability.",
              },
              {
                title: "Preserve Original Content Quality",
                description:
                  "Modern PDF cropper tools maintain text clarity and image quality while trimming pages accurately.",
              },
              {
                title: "Batch Crop Multiple Pages",
                description:
                  "With crop PDF online, users can apply the same crop settings across multiple pages at once.",
              },
              {
                title: "Offline Processing for Privacy",
                description:
                  "This offline crop PDF tool processes files locally, keeping sensitive documents secure.",
              },
              {
                title: "Save Time with Automated Cropping",
                description:
                  "Our PDF trimmer online automates the cropping process, saving time compared to manual editing.",
              },
            ]}
          />
          {/* FAQ */}
          <MiscFAQ
            faq_list={[
              {
                title: "How can I crop a PDF online for free?",
                description:
                  "Visit ShivaPDF.com and open the Crop PDF tool. Select your PDF file, adjust the cropping area, and apply the changes. Download the cropped PDF directly to your device when processing is complete."
              },
              {
                title: "Can I crop a PDF without uploading it?",
                description:
                  "Yes, ShivaPDF processes PDF files locally in your browser, so you can crop documents without uploading their contents to a remote server. Your files remain on your device during local processing, helping protect your privacy."
              },
              {
                title: "Is ShivaPDF's PDF cropper free to use?",
                description:
                  "Yes, ShivaPDF offers a free online PDF cropping tool that lets you adjust PDF page boundaries without installing additional software, subject to any usage limits displayed on the website."
              },
              {
                title: "Can I crop a PDF offline?",
                description:
                  "You may need an internet connection to open ShivaPDF.com initially. If the Crop PDF tool and its required resources are available locally, you can crop PDF files without an active internet connection."
              },
              {
                title: "Are my PDF files safe when using ShivaPDF?",
                description:
                  "ShivaPDF is designed to process supported PDF files locally in your browser. Because document contents do not need to be uploaded to a remote server for local processing, you can crop PDFs while keeping their contents on your device."
              },
              {
                title: "How do I crop PDF margins?",
                description:
                  "Open the Crop PDF tool on ShivaPDF.com, select your document, and adjust the crop boundaries to remove unwanted white space, borders, or margins. Apply the changes and download the updated PDF."
              },
              {
                title: "Can I crop all pages of a PDF at once?",
                description:
                  "If supported by the cropping tool, you can apply the same crop boundaries to all pages of your PDF. This is useful for removing consistent margins from multi-page documents."
              },
              {
                title: "Can I crop only selected PDF pages?",
                description:
                  "Depending on the available options, you can crop specific pages or a selected page range while leaving the other pages unchanged. Review the page selection settings before applying the crop."
              },
              {
                title: "Will cropping a PDF reduce its quality?",
                description:
                  "Cropping generally changes the visible page boundaries without reducing the resolution of existing text or images. The final result depends on the PDF processing method and how the document is saved."
              },
              {
                title: "Does cropping a PDF permanently delete content outside the crop area?",
                description:
                  "Not necessarily. Some PDF cropping methods hide content outside the visible page boundaries without permanently removing it. If you need to protect confidential information, use a suitable redaction tool instead of relying on cropping alone."
              },
              {
                title: "Can I crop scanned PDF documents?",
                description:
                  "Yes, you can crop supported scanned PDFs to remove unwanted borders, empty margins, or surrounding areas. The visible scanned content within the selected crop area is retained."
              },
              {
                title: "Can I crop a PDF on my mobile phone?",
                description:
                  "Yes, you can access ShivaPDF.com through a supported mobile browser on an iPhone, Android phone, or tablet. Select your PDF, adjust the crop area, and save the processed document."
              },
              {
                title: "Do I need to install software to crop a PDF?",
                description:
                  "No, ShivaPDF provides a browser-based PDF cropping tool. You can edit supported PDF files directly in your browser without installing a separate application."
              },
              {
                title: "Can I crop a PDF to a custom page size?",
                description:
                  "If custom cropping is supported, you can adjust the crop boundaries to create the desired visible page dimensions. This is useful for preparing PDFs for printing, sharing, or document formatting."
              },
              {
                title: "Will cropping change my original PDF file?",
                description:
                  "Your original PDF remains unchanged when you download the cropped result as a separate file. Keep a copy of the original document if you may need to restore its original page boundaries."
              },
              {
                title: "Can I crop a password-protected PDF?",
                description:
                  "Some password-protected PDFs require authorization or unlocking before they can be edited. Only modify protected documents when you have permission to do so."
              },
              {
                title: "Why should I use a local PDF cropper?",
                description:
                  "A local PDF cropper processes supported documents directly in your browser, helping keep file contents on your device. It also avoids unnecessary file uploads and lets you crop PDFs without installing desktop software."
              },
              {
                title: "Can I crop a PDF without creating an account?",
                description:
                  "You can use ShivaPDF's PDF cropping tool without creating an account if registration is not required by the website. Check the tool page for any applicable usage restrictions."
              },
              {
                title: "How do I download a cropped PDF from ShivaPDF?",
                description:
                  "After adjusting the cropping boundaries and applying your changes, select the download option to save the updated PDF to your device. Open the downloaded file to verify the page boundaries and content."
              },
              {
                title: "Does ShivaPDF store my PDF files?",
                description:
                  "ShivaPDF's local-processing workflow is designed to handle supported PDF files in your browser without uploading their contents to a remote server. This helps keep your documents on your device during processing."
              }
            ]} />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app-bundle/id${1863317370}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Recommended Tools */}
          <MiscRecommendedPages />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default CropPDFMain;
